import React from 'react'
import styled from 'styled-components'
import LiveModal from 'live/components/ui/Modal'
import i18n from 'live/services/i18n'
import { ModalData } from './Transfer'
import { api } from '../services/api'
import _ from 'lodash'

import globalNotification from 'live/services/global-notification'
import { GlobalNotification } from './GlobalNotification'
interface TransferModalProps {
    isTransferModalOpen: boolean
    setIsTransferModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    modalData: ModalData
}

export const TransferModal = ({
    isTransferModalOpen,
    setIsTransferModalOpen,
    modalData
}: TransferModalProps): JSX.Element => {
    const [thereIsAlreadyAnIntervention, setThereIsAlreadyAnIntervention] = React.useState<string>('')
    const [errors, setErrors] = React.useState<{ key: string; message: string }[]>([])

    const hadleTextError = (text: string): { key: string; message: string }[] => {
        const mountedErrors = []

        if (_.isEmpty(JSON.parse(text))) {
            globalNotification.success(
                <GlobalNotification title={i18n('Wells interventions tranfered successfully!')} />
            )
            resetStates()

            return []
        }

        if (text.includes('overlap') && text.toLowerCase().includes('intervention')) {
            const parsedText = JSON.parse(text)
            const textValues = Object.values(parsedText)
            const textFull = textValues?.find(Boolean)
            const date = String(textFull)
                ?.split('other')[1]
                .trim()
            setThereIsAlreadyAnIntervention(date)
        } else {
            const textObj = JSON.parse(text)
            if (_.isObject(textObj)) {
                Object.keys(textObj)?.forEach(key => {
                    const isGeneral = key?.toLowerCase()?.includes('general')
                    const checkIfIsArray = Array.isArray(textObj[key])

                    if (checkIfIsArray) {
                        textObj[key]?.forEach(error => {
                            mountedErrors.push({
                                key,
                                message: isGeneral ? `${error}` : `${key}: ${error}`
                            })
                        })

                        return []
                    }

                    mountedErrors.push({
                        key,
                        message: isGeneral ? `${textObj[key]}` : `${key}: ${textObj[key]}`
                    })
                })
            }
        }

        return mountedErrors
    }

    const handleTransfer = async (): Promise<void> => {
        if (thereIsAlreadyAnIntervention) {
            await api
                .wellsInterverntionImporter({
                    wellId: modalData?.wellId,
                    rigId: modalData?.rigId,
                    interventionId: modalData?.interventionId,
                    deleteStaticData: 'true'
                })
                .then(resp => {
                    resp.text().then(async text => {
                        try {
                            if (_.isEmpty(JSON.parse(text))) {
                                globalNotification.success(
                                    <GlobalNotification title={i18n('Wells interventions tranfered successfully!')} />
                                )
                                resetStates()
                            } else {
                                const mountedErrors = hadleTextError(text)
                                setErrors(mountedErrors)
                                setThereIsAlreadyAnIntervention('')
                            }
                        } catch (error) {}
                    })
                })

            return
        }
        await api
            .wellsInterverntionImporter({
                wellId: modalData?.wellId,
                rigId: modalData?.rigId,
                interventionId: modalData?.interventionId,
                deleteStaticData: 'false'
            })
            .then(resp => {
                resp.text().then(async text => {
                    try {
                        const mountedErrors = hadleTextError(text)
                        setErrors(mountedErrors)
                    } catch (error) {
                        console.error('Invalid JSON parse')
                    }
                })
            })
            .catch(err => {
                console.error('Error transferring', err)
            })
    }

    const resetStates = (): void => {
        setThereIsAlreadyAnIntervention('')
        setErrors([])
        setIsTransferModalOpen(false)
    }

    return (
        <LiveModalWrapper show={isTransferModalOpen}>
            <LiveModal.Header>
                <LiveModal.Title>
                    <span>{i18n('Transfer to KPI Static Data')}</span>
                </LiveModal.Title>
                <i
                    className="far fa-times close-btn"
                    onClick={() => {
                        resetStates()
                    }}
                />
            </LiveModal.Header>

            <LiveModal.Body>
                <ModalSection>
                    <ModalSectionItem>
                        <span>{i18n('Well')}</span>
                        <span>{modalData?.wellName || '-'}</span>
                    </ModalSectionItem>
                    <ModalSectionItem>
                        <span>{i18n('Intervention Type')}</span>
                        <span style={{ textTransform: 'capitalize' }}>{modalData?.interventionType || '-'}</span>
                    </ModalSectionItem>
                    <ModalSectionItem>
                        <span>{i18n('Rig')}</span>
                        <span>{modalData?.rigName || '-'}</span>
                    </ModalSectionItem>
                    <ModalSectionItem>
                        <span>Status</span>
                        <span style={{ textTransform: 'capitalize' }}>{modalData?.status || '-'}</span>
                    </ModalSectionItem>
                </ModalSection>

                <span id="execution-data">{i18n('Execution Data')}</span>

                <ModalSection style={{ gridTemplateColumns: '2fr 2fr 2fr' }}>
                    <ModalSectionItem>
                        <span>{i18n('Intervention')}</span>
                        <span>{modalData?.interventionName || '-'}</span>
                    </ModalSectionItem>
                    <ModalSectionItem>
                        <span>{i18n('Start Date')}</span>
                        <span>
                            {!modalData?.startDate || modalData?.startDate === 0
                                ? '-'
                                : new Date(modalData?.startDate).toLocaleString()}
                        </span>
                    </ModalSectionItem>
                    <ModalSectionItem>
                        <span>{i18n('End Date')}</span>
                        <span>
                            {!modalData?.endDate || modalData?.endDate === 0
                                ? '-'
                                : new Date(modalData?.endDate).toLocaleString()}
                        </span>
                    </ModalSectionItem>
                </ModalSection>

                {thereIsAlreadyAnIntervention && (
                    <ModalSectionWarning>
                        <div>
                            <i className="far fa-exclamation-triangle"></i>
                        </div>
                        <div>
                            <span>{i18n('Attention!')}</span>
                            <span>
                                {i18n(
                                    `There is an intervention in the selected period ${thereIsAlreadyAnIntervention}. Are you sure you want to overwirte it?`
                                )}
                            </span>
                            <span>{i18n('This action cannot be undone.')}</span>
                        </div>
                    </ModalSectionWarning>
                )}

                {errors?.length > 0 && (
                    <ModalSectionErrors>
                        <div id="errors-header">
                            <span>{`${i18n('Checklist for Intervention')} ${modalData?.interventionName}`}</span>
                            <span>{`(${errors?.length}) ${i18n(
                                errors?.length > 1 ? 'errors found' : 'error found'
                            )}`}</span>
                        </div>
                        <ModalSectionErrorsList>
                            {errors?.map((error, index) => {
                                return (
                                    <div key={`${index}_${error}`}>
                                        <i className="far fa-exclamation-triangle"></i>
                                        <span>{error.message}</span>
                                    </div>
                                )
                            })}
                        </ModalSectionErrorsList>
                    </ModalSectionErrors>
                )}
            </LiveModal.Body>

            <LiveModal.Footer>
                <ActionBtn
                    style={{ opacity: errors?.length > 0 ? 0.3 : 1 }}
                    type="button"
                    onClick={handleTransfer}
                    className="btn btn-primary"
                    disabled={errors?.length > 0}
                >
                    <i className="far fa-file-export"></i>
                    {i18n('Confirm transfer')}
                </ActionBtn>
                <ActionBtn
                    type="button"
                    onClick={() => {
                        resetStates()
                    }}
                    className="btn btn-secondary"
                >
                    {i18n('Cancel')}
                </ActionBtn>
            </LiveModal.Footer>
        </LiveModalWrapper>
    )
}

const ModalSectionWarning = styled.div`
    border: 1px solid var(--yellow-700);
    background: var(--yellow-200);
    border-radius: 4px;
    padding: 16px 8px;
    display: flex;
    margin-top: 14px;
    margin-bottom: 14px;

    font-size: 13px;
    font-style: normal;
    line-height: 16px;

    & > div:first-child {
        width: 24px;
    }

    & > div:last-child {
        display: flex;
        flex-direction: column;

        & > span:first-child {
            color: var(--red-500);
            font-weight: 600;
            margin-bottom: 8px;
        }

        & > span:nth-child(2) {
            color: var(--gray-800);
            font-weight: 400;
        }

        & > span:last-child {
            color: var(--gray-800);
            font-weight: 600;
            margin-top: 8px;
        }
    }
`

const ModalSectionErrors = styled.div`
    display: flex;
    flex-direction: column;

    #errors-header {
        margin-bottom: 4px;
        margin-top: 8px;
        span {
            color: var(--gray-800);
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
        }
        & > span:last-child {
            margin-left: 4px;
            color: var(--red-700);
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
        }
    }

    #errors-footer {
        margin-top: 4px;
        i {
            margin-right: 4px;
            color: #707070;
        }
    }
`

const ModalSectionErrorsList = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto !important;

    height: auto;
    max-height: 112px;
    width: 100%;

    padding: 16px;

    border-radius: 3px;
    border: 1px solid var(--gray-400);
    background: var(--gray-0);

    // Changing scrollbar css
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* outside */
    ::-webkit-scrollbar-track {
        background: var(--gray-100);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        height: 16px;
        border-radius: 8px;
        background: var(--gray-500);
    }

    & > div:not(:last-child) {
        margin-bottom: 16px;
    }

    & > div > i {
        margin-right: 16px;
    }
`

const ModalSection = styled.div`
    display: grid;
    grid-template-columns: 2fr 2fr 1fr 1fr;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid var(--gray-400);
    background: var(--gray-100);
`

const ModalSectionItem = styled.div`
    display: flex;
    flex-direction: column;

    & > span:first-child {
        font-weight: 600;
    }

    &:not(:first-child) {
        margin-left: 16px;
    }
`

const LiveModalWrapper = styled(LiveModal)`
    display: flex !important;

    #execution-data {
        font-weight: 600;
        font-size: 14px;
        margin-top: 8px;
        margin-bottom: -10px;
    }

    .modal-dialog {
        margin: auto;
        width: 640px !important;
    }

    .close-btn {
        position: absolute;
        top: 13px;
        right: 16px;
        z-index: 9999;

        font-size: 16px;

        cursor: pointer;

        &:hover {
            opacity: 0.8;
        }
    }

    .modal-header {
        padding: 0 0 0 16px;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 24px 16px;
    }

    .modal-footer {
        display: flex;
        align-items: center;
        gap: 4px;

        margin: 0;
        padding: 16px 12px;
    }
`

const ActionBtn = styled.button`
    font-size: 13px;
    font-weight: 600;
    padding: 6px 24px;

    border: none;
    border-radius: 3px;

    i {
        margin-right: 8px;
    }

    &:hover {
        opacity: 0.8;
    }

    &.btn.btn-primary {
        border: 1px solid var(--blue-500);
        color: white;
        background-color: var(--blue-500);
    }

    &.btn.btn-secondary {
        border: 1px solid var(--gray-400);
        background-color: transparent;
    }
`
